type Message = {
  message: string;
};

type ShapedError = {
  shape: Message;
};

export type ErrorMessageType = string | Message | ShapedError | unknown;

const isShapedError = (
  error?: ErrorMessageType | null,
): error is ShapedError => {
  return !!error && !!(error as ShapedError).shape;
};

export const getErrorMessage = (
  error?: ErrorMessageType | null,
): ErrorMessageType => {
  if (!error) {
    return undefined;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (isShapedError(error)) {
    return error.shape.message;
  }

  return (error as { message: string }).message;
};
